import React from 'react'
import { groups, others } from 'constants/pod-groups'

import { Container, Title, Item, Icon, Content } from './ProductTooltip.style'

const ProductTooltipOthers = () => (
    <Container
        data-testid={`${groups.OUTROS}Tooltip`}
        style={{ maxWidth: '280px' }}
    >
        <Title>QUAIS BENEFÍCIOS ESTÃO INCLUÍDOS EM OUTROS AUXÍLIOS?</Title>
        <Content>
            {others.map((other) => (
                <Item key={other.title} style={{ alignItems: 'center' }}>
                    <div>
                        <Icon
                            src={other.icon}
                            alt={`Icone Alelo Pod ${other.title}`}
                        />
                    </div>
                    <p>{other.title}</p>
                </Item>
            ))}
        </Content>
    </Container>
)

export default ProductTooltipOthers
